import { DeleteInternalAuditResultsDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

export const useDeleteInternalAuditResults = createMutationHook({
  name: 'deleteInternalAuditResults',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.internalAuditResult.delete.mutationOptions({ onSuccess }),
  mapInput: (ids: string[]) => ({ Ids: ids }),
  mapResponse: (): void => undefined,
  invalidate: (trpc) => [
    trpc.frontend.internalAuditResult.pathKey(),
    trpc.frontend.assessment.internalAuditResultCount.queryKey(),
    // COI-471 parity: Apollo twin also evicts `internal_audit_report`.
    trpc.frontend.internalAuditReport.pathKey(),
  ],
  graphqlDocument: DeleteInternalAuditResultsDocument,
  graphqlVariables: (ids: string[]) => ({ Ids: ids }),
  mapGraphqlResponse: (): void => undefined,
  evictFields: [
    'obligation_internal_audit_result',
    'document_internal_audit_result',
    'risk_controlled_internal_audit_result',
    'risk_uncontrolled_internal_audit_result',
    'control_test_internal_audit_result',
    'impact_internal_audit_rating',
    'internal_audit_report',
    'obligation_internal_audit_result_aggregate',
    'document_internal_audit_result_aggregate',
    'risk_controlled_internal_audit_result_aggregate',
    'risk_uncontrolled_internal_audit_result_aggregate',
  ],
});
